export const QUESTION_BANKS = 'questionBanks';
export const GET_QUESTION_BANKS = `${QUESTION_BANKS}/getQuestionBanksAction`;
export const DELETE_QUESTION_BANK = `${QUESTION_BANKS}/deleteQuestionBankAction`;
export const SET_QUESTION_BANK = `${QUESTION_BANKS}/setQuestionBankAction`;
export const GET_QUESTION_BANK = `${QUESTION_BANKS}/getQuestionBankAction`;
